export const GET_LENS_PACKAGES = 'editPower/GET_LENS_PACKAGES';
export const GET_LENS_PACKAGES_SUCCESS = 'editPower/GET_LENS_PACKAGES_SUCCESS';
export const GET_LENS_PACKAGES_FAIL = 'editPower/GET_LENS_PACKAGES_FAIL';
export const GET_POWERS = 'editPower/GET_POWERS';
export const GET_POWERS_SUCCESS = 'editPower/GET_POWERS_SUCCESS';
export const GET_POWERS_FAIL = 'editPower/GET_POWERS_FAIL';
